"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSummaryResults = exports.questions = void 0;

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var MOTIVATIONAL_INTERVIEWING_ADDICTIONS = "MOTIVATIONAL_INTERVIEWING_ADDICTIONS";
var questions = [{
  prompt: "Can you think of a recent time when you were obsessing or thinking about alcohol or drugs?",
  type: "radio",
  options: ["Yes", "No"],
  batteryId: MOTIVATIONAL_INTERVIEWING_ADDICTIONS,
  meta: {
    summaryTitle: "Can you think of a recent time when you were obsessing or thinking about alcohol or drugs?"
  }
}, {
  prompt: "Can you think of a recent time where you tried to control your behaviour around drinking or drugs but it didn’t work?",
  type: "radio",
  options: ["Yes", "No"],
  batteryId: MOTIVATIONAL_INTERVIEWING_ADDICTIONS,
  meta: {
    summaryTitle: "Can you think of a recent time where you tried to control your behaviour around drinking or drugs but it didn’t work?"
  }
}, {
  prompt: "Can you think of a recent time where you lied, covered up or minimised your behaviour to someone else?",
  type: "radio",
  options: ["Yes", "No"],
  batteryId: MOTIVATIONAL_INTERVIEWING_ADDICTIONS,
  meta: {
    summaryTitle: "Can you think of a recent time where you lied, covered up or minimised your behaviour to someone else?"
  }
}, {
  prompt: "Have you noticed effects on your physical health?",
  type: "radio",
  options: ["Yes", "No"],
  batteryId: MOTIVATIONAL_INTERVIEWING_ADDICTIONS,
  meta: {
    summaryTitle: "Have you noticed effects on your physical health?"
  }
}, {
  prompt: "Effects on your emotional or mental health?",
  type: "radio",
  options: ["Yes", "No"],
  batteryId: MOTIVATIONAL_INTERVIEWING_ADDICTIONS,
  meta: {
    summaryTitle: "Effects on your emotional or mental health?"
  }
}, {
  prompt: "Effects on your social life?",
  type: "radio",
  options: ["Yes", "No"],
  batteryId: MOTIVATIONAL_INTERVIEWING_ADDICTIONS,
  meta: {
    summaryTitle: "Effects on your social life?"
  }
}, {
  prompt: "Effects on your work or school life?",
  type: "radio",
  options: ["Yes", "No"],
  batteryId: MOTIVATIONAL_INTERVIEWING_ADDICTIONS,
  meta: {
    summaryTitle: "Effects on your work or school life?"
  }
}, {
  prompt: "Effects on your character, morals or values?",
  type: "radio",
  options: ["Yes", "No"],
  batteryId: MOTIVATIONAL_INTERVIEWING_ADDICTIONS,
  meta: {
    summaryTitle: "Effects on your character, morals or values?"
  }
}, {
  prompt: "Effects on your financial situation?",
  type: "radio",
  options: ["Yes", "No"],
  batteryId: MOTIVATIONAL_INTERVIEWING_ADDICTIONS,
  meta: {
    summaryTitle: "Effects on your character, morals or values?Effects on your financial situation?"
  }
}, {
  prompt: "Contact with police or courts?",
  type: "radio",
  options: ["Yes", "No"],
  batteryId: MOTIVATIONAL_INTERVIEWING_ADDICTIONS,
  meta: {
    summaryTitle: "Contact with police or courts?"
  }
}, {
  prompt: "Memory loss?",
  type: "radio",
  options: ["Yes", "No"],
  batteryId: MOTIVATIONAL_INTERVIEWING_ADDICTIONS,
  meta: {
    summaryTitle: "Memory loss?"
  }
}, {
  prompt: "Accidents or dangerous situations?",
  type: "radio",
  options: ["Yes", "No"],
  batteryId: MOTIVATIONAL_INTERVIEWING_ADDICTIONS,
  meta: {
    summaryTitle: "Accidents or dangerous situations?"
  }
}, {
  prompt: "Destructive behaviour (towards yourself or others)?",
  type: "radio",
  options: ["Yes", "No"],
  batteryId: MOTIVATIONAL_INTERVIEWING_ADDICTIONS,
  meta: {
    summaryTitle: "Destructive behaviour (towards yourself or others)?"
  }
}, {
  prompt: "Do you feel like you have to keep busy most or all of the time?",
  type: "radio",
  options: ["Yes", "No"],
  batteryId: MOTIVATIONAL_INTERVIEWING_ADDICTIONS,
  meta: {
    summaryTitle: "Do you feel like you have to keep busy most or all of the time?"
  }
}, {
  prompt: "Trouble sharing feelings with others?",
  type: "radio",
  options: ["Yes", "No"],
  batteryId: MOTIVATIONAL_INTERVIEWING_ADDICTIONS,
  meta: {
    summaryTitle: "Trouble sharing feelings with others?"
  }
}, {
  prompt: "Making promises to yourself or others that were broken?",
  type: "radio",
  options: ["Yes", "No"],
  batteryId: MOTIVATIONAL_INTERVIEWING_ADDICTIONS,
  meta: {
    summaryTitle: "Making promises to yourself or others that were broken?"
  }
}, {
  prompt: "Using to get rid of emotional pain?",
  type: "radio",
  options: ["Yes", "No"],
  batteryId: MOTIVATIONAL_INTERVIEWING_ADDICTIONS,
  meta: {
    summaryTitle: "Using to get rid of emotional pain?"
  }
}, {
  prompt: "Given up hobbies, interests, career choices, education or people because you preferred to drink or use?",
  type: "radio",
  options: ["Yes", "No"],
  batteryId: MOTIVATIONAL_INTERVIEWING_ADDICTIONS,
  meta: {
    summaryTitle: "Given up hobbies, interests, career choices, education or people because you preferred to drink or use?"
  }
}];
exports.questions = questions;

var getSummaryResults = function getSummaryResults(answers) {
  return questions.map(function (question, index) {
    var _answers$question$bat;

    if (!question.hideFromSummary && (_answers$question$bat = answers[question.batteryId][index]) !== null && _answers$question$bat !== void 0 && _answers$question$bat.toString()) {
      if (question.type === "radio") {
        return {
          question: question,
          answer: question.options[answers[question.batteryId][index]]
        };
      } else {
        return {
          question: question,
          answer: answers[question.batteryId][index]
        };
      }
    }
  }).filter(function (item) {
    return _typeof(item) === "object";
  });
};

exports.getSummaryResults = getSummaryResults;